import { useState, useEffect, useContext } from "react";
import TalentSidebar from "../../components/UI/Talent/Sidebar/sidebar";
import Header from "../../components/UI/Talent/Header/header";
import { UserContext } from "../../context";
import classes from "./dashboard.module.css";
import { Outlet } from "react-router-dom";
import { talentProfile } from "../../services/talentCalls";
import { DocumentHeader } from "../../components/Seo";

const DashboardLayout = () => {
  const { setCount, data, setData } = useContext(UserContext);

  useEffect(() => {
    setCount(11);
  }, []);

  const getUserProfile = async () => {
    try {
      const res = await talentProfile();
      if (res?.data?.data?.talent) {
        setData(res?.data?.data?.talent);
      }
    } catch (error) {
      // Swallowing this silently left `data` undefined with no trace, which then
      // drove verification gates elsewhere in the dashboard to the wrong answer.
      console.error("Failed to load talent profile", error);
    }
  };

  useEffect(() => {
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Sidebar state ─────────────────────────────────────────────────────────
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);

  // ── Mobile search state ───────────────────────────────────────────────────
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 768) setSidebarMobileOpen(false);
  }, []);

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth > 768) setSidebarMobileOpen(false);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const handleSidebarToggle = () => {
    if (window.innerWidth <= 768) {
      setSidebarMobileOpen((p) => !p);
    } else {
      setSidebarCollapsed((p) => !p);
    }
  };

  const mainClass = [classes.mainContent, sidebarCollapsed ? classes.mainCollapsed : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="main-dashboard-page">
      <DocumentHeader title="Talent home" />

      <Header
        sidebarCollapsed={sidebarCollapsed}
        sidebarMobileOpen={sidebarMobileOpen}
        mobileSearchOpen={mobileSearchOpen}
        onSidebarToggle={handleSidebarToggle}
        onMobileSearchToggle={() => setMobileSearchOpen((p) => !p)}
        onMobileSearchClose={() => setMobileSearchOpen(false)}
        data={data}
      />

      <TalentSidebar
        collapsed={sidebarCollapsed}
        mobileOpen={sidebarMobileOpen}
        onOverlayClick={() => setSidebarMobileOpen(false)}
        data={data}
      />

      <main className={mainClass}>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
